export default __webpack_public_path__ + "static/chrisKitten-4ec0c1313198408cc535ab2bac0de962.webp";